import { render, staticRenderFns } from "./LoanExtension.vue?vue&type=template&id=010b5b59"
import script from "./LoanExtension.vue?vue&type=script&lang=js"
export * from "./LoanExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports